import { require200Status } from "../../utils/response.js";
import { transformWithSpec } from "../../../utils/response.js";
function passwordEndpoints(builder) {
  return {
    updatePassword: builder.mutation({
      invalidatesTags: ["password"],
      query: (body) => ({
        url: `/member/password`,
        validateStatus: require200Status,
        method: "POST",
        body
      }),
      transformResponse: transformWithSpec()
    })
  };
}
export {
  passwordEndpoints as default
};
